import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=6f5d916a&"
import script from "./PasswordResetView.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetView.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports